import { createSlice } from '@reduxjs/toolkit';
import LoadingStatus from 'enums/loadingStatus';

export const DATA_SLICE_KEY = 'nativeInteractiveSiteMapData';
export function createNativeInteractiveSiteMapDataSlice({
  mapLibraryStatus = LoadingStatus.Idle.toString(),
  mapLibraryError = null,
} = {}) {
  return createSlice({
    name: DATA_SLICE_KEY,
    initialState: {
      mapLibraryStatus,
      mapLibraryError,
    },
    reducers: {
      mapLibraryFetch: (state) => {
        state.mapLibraryStatus = LoadingStatus.Loading.toString();
        state.mapLibraryError = null;
      },
      mapLibraryLoaded: (state) => {
        state.mapLibraryStatus = LoadingStatus.Succeeded.toString();
        state.mapLibraryError = null;
      },
      mapLibraryErrored: (state, action) => {
        state.mapLibraryStatus = LoadingStatus.Failed.toString();
        state.mapLibraryError = action.payload;
      },
    },
  });
}